import React from 'react'
import SubmissionSuccess from '../../components/forms/SubmissionSuccess'

export default function QuotationSuccess({heading,para,onHomeClick} : any) {
  return (
    <SubmissionSuccess heading={heading}  para={para} onHomeClick={onHomeClick}/>
  )
}
